export const LIST_REDUCER_STATE_ID = 'list';

export const DEFAULT_LIST_PAGE_SIZE = 10;

export const LIST_WRAPPER_BOX_MIN_HEIGHT_PX = 280;
